import { useEffect } from 'react';

import Loader from 'Shared/Components/Loader/Loader';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';

const SignInCallbackPage = () => {
  const { signinRedirectCallback } = useUserManager();

  useEffect(() => {
    signinRedirectCallback();
  });

  return <Loader active={true} />;
};

export default SignInCallbackPage;
